import { j as P } from "../../../../jsx-runtime.BREq8dyb.js";
import { b as W } from "../../../../lodash.DGoHQECz.js";
import { memo as j, useState as o, useEffect as t } from "react";
import "../../contexts/DatasetContext/DatasetContext.js";
import "../../contexts/FeatureContext/FeatureContext.js";
import { useFile as I } from "../../contexts/FileContext/FileContext.js";
import "../../contexts/IntrospectionContext/IntrospectionContext.js";
import "../../contexts/NavigatorContext/NavigatorContext.js";
import { DEFAULT_MAPPED_COLUMNS as m, DEFAULT_HASHED_COLUMNS as c, DEFAULT_AUTOFIX as E, DEFAULT_DROP_FAILED_ROWS as O, DEFAULT_SHOW_COLUMNS as f, DEFAULT_SHOW_ROWS as h, OptionsProvider as V } from "../../contexts/OptionsContext/OptionsContext.js";
import { useSchema as b } from "../../contexts/SchemaContext/SchemaContext.js";
import "../../contexts/TypificationContext/TypificationContext.js";
import "../../contexts/WorkerContext/WorkerContext.js";
import { ShowRows as _ } from "../../types/index.js";
const k = j(({
  children: C
}) => {
  const {
    schema: F
  } = b(), {
    columns: w
  } = F || {}, {
    file: L,
    fileHeaders: U,
    fileValuesDelimiter: R
  } = I(), [T, g] = o(!1), [r, n] = o(!1), [x, s] = o(m), [H, i] = o(c), [M, d] = o(E), [a, S] = o(O), [N, l] = o(f), [y, e] = o(h);
  t(() => {
    n(!1), s(m), i(c), l(f), e(h), d(E), S(O);
  }, [L]), t(() => {
    n(!1), s(m), i(c), l(f), e(h);
  }, [R]), t(() => {
    e(a ? _.Valid : _.All);
  }, [a]);
  const p = U?.length || 0, u = w?.length || 0;
  return t(() => {
    const A = p > 0 && u > 0 ? Array.from(Array(Math.min(u, p)).keys()) : m;
    s((D) => W(D, A) || r ? D : A);
  }, [u, p, r]), /* @__PURE__ */ P.jsx(V, { value: {
    autofix: M,
    deferringSchema: r,
    dropFailedRows: a,
    hashedColumns: H,
    mappedColumns: x,
    mapping: T,
    setAutofix: d,
    setDeferringSchema: n,
    setDropFailedRows: S,
    setHashedColumns: i,
    setMappedColumns: s,
    setMapping: g,
    setShowColumns: l,
    setShowRows: e,
    showColumns: N,
    showRows: y
  }, children: C });
});
k.displayName = "OptionsContainer";
export {
  k as default
};
//# sourceMappingURL=OptionsContainer.js.map
